import { render, staticRenderFns } from "./SmartDocIcon.vue?vue&type=template&id=0dbdca23&"
import script from "./SmartDocIcon.vue?vue&type=script&lang=js&"
export * from "./SmartDocIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports